import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, Input, Label} from 'reactstrap';

import { useDispatch } from 'react-redux';
import { DELETE_GROUP } from '../slices/thunks';




const Prompt_Delete_modal = ({ group_id , group_name }) => {
    const [group_name_confirm, setgroup_name_confirm] = useState('')
    const dispatch = useDispatch();
    
    const onChangegroup_name_confirm = (e) => {
        setgroup_name_confirm(e.target.value)
    }
    


    const [modal_standard, setmodal_standard] = useState(false);
        function tog_standard() {
            setmodal_standard(!modal_standard);
        }

    


  return (
    <>
    <Button color="primary" onClick={() => tog_standard()}><i className='ri-delete-bin-line'></i></Button>
    {/* Default Modal */}
            <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>

                    Delete Group
                </ModalHeader>
                <ModalBody>
                    <Label htmlFor="basiInput" className="form-label">Please enter the name of group</Label>
                    <Input onChange={onChangegroup_name_confirm} type="text" className="form-control" id="basiInput" />
                    {/* <Input type="text" className="form-control" id="basiInput" /> */}
                </ModalBody>
                <div className="modal-footer">
                    <Button
                        color="light"
                        // onClick={() => {
                        //     tog_standard();
                        // }}
                    >
                        Close
                    </Button>
                    <Button
                        color="primary"
                        onClick={()=>{
                            if(group_name_confirm === group_name){
                                dispatch(DELETE_GROUP({group_id , group_name}))
                                tog_standard()
                            }else{
                                alert("Group Name is not correct")
                            }
                        }}
                    >
                        Delete Group
                    </Button>
                </div>
            </Modal>
    </>
  )
}

export default Prompt_Delete_modal